
import SecondServer from '../database/SecondServer'
import {convertZoneToLocalTime} from '../timeFunctions/TimeZone'
import {apiFormat} from '../timeFunctions/timeFns'
import { urlDeviceReadings } from '../database/apiUrls';

// dataType is SensorData or NetworkData for the api
export async function fetchHistory (radioId, from, to, dataType, auth, site) {
    const dcap_tz = sessionStorage.getItem ('site-tz');
    const d1 = convertZoneToLocalTime (from, dcap_tz);
    const d2 = convertZoneToLocalTime (to, dcap_tz);
    const url = urlDeviceReadings(site, radioId, apiFormat(d1), apiFormat(d2), 5000, dataType)
/*    const url = '/tehama/sites/devices/'+radioId+'/historical-data?' + 
      'start_ts='+apiFormat(d1)+'&end_ts='+apiFormat(d2)+
      '&limit=5000&data_type='+dataType+'&access_code='+site; */
    return ssApiCall(auth, url);
}

//"data": {
//    "readings": [
//        {
//          "ReadTime": "2019-09-01 03:11:33",
//          "BattVolt": 2694,
//        },
// returns array readTime
export function jsonToArray(json_data, wanted_property) {
    let result = [];
    if (json_data && wanted_property)
        json_data.forEach (arrayItem => result.push(arrayItem[wanted_property]));
    return result;
}

export async function ssApiCall(auth, url) {
    let ss = new SecondServer(auth);
    return await ss.apiDataObj (url);
}

export function titleLabel (label, data) {
    const temp = data ? data.trim(): "";
    return temp ? label + temp : "";
}

// maps from the names used in table api calls to the equivalent names
// used in the api for fetching historical data
export function mapAPIProperty (propName) {
    const mapObj = {BattVolt: 'BattVolt', LQ: 'LinkQuality', RSSI: 'RcvRssi'}
    const newProp = mapObj[propName];
    return newProp ? newProp : propName;
}

//export function deDupe2(xaxis, series1) {
  //let uniqueTimes = [...new Set(xaxis)]
  //console.log (uniqueTimes)
//}

// because duplicates just kill bar charts
export function duplicatesIndex (xaxis) {
  let arrDupIndices = [];
  if (typeof xaxis[0] === 'object') {
    for (let i = 1; i < xaxis.length; ++i) {
      if (xaxis[i].getTime() === xaxis[i-1].getTime())
        arrDupIndices.push(i);
    }
  }
  else {
    for (let i = 1; i < xaxis.length; ++i) {
      if (xaxis[i] === xaxis[i-1])
        arrDupIndices.push(i);
    }
  }
  return arrDupIndices
}
export function filterIndex (arrIndex, toFilter) {
  return toFilter.filter((item, index) => arrIndex.indexOf(index) < 0)
}

export function deDupe(xaxis, series1) {
  const arrDupIndices = duplicatesIndex(xaxis)
  let filteredXaxis = xaxis.filter((value, index) => {
    return arrDupIndices.indexOf(index) < 0;
  })
  let filteredSeries1 = series1.filter((value, index) => {
    return arrDupIndices.indexOf(index) < 0;
  });
  filteredSeries1 = removeUnits (filteredSeries1);
  return {series1: filteredSeries1, xaxis: filteredXaxis };
}

function removeUnits (series) {
  return series.map(item => typeof item?.includes === 'function' && item.includes(' ') ?
    item.substring(0, item.indexOf(' ')) : item)
}
